<template>
  <component
    :is="Teleport"
    to="title"
  >
    {{ pageTitle }}
  </component>
</template>

<script lang="ts" setup>
import useTeleport from '@/composables/useTeleport';

const {
  Teleport,
} = useTeleport();

withDefaults(defineProps<{
  pageTitle?: string,
}>(), {
  pageTitle: '',
});
</script>

